/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { isEmpty } from '@ember/utils';

export default class AdminRoute extends Route {
  // Services
  @service
  store;

  model() {
    let sickbayVisits = this.modelFor('application').sickbayVisits;
    if (!isEmpty(sickbayVisits.update)) {
      sickbayVisits.update();
    }
    return hash({
      sickbayVisits,
      sickbayPage: this.store
        .query('posts/page', { isSickbay: true })
        .then((pages) => {
          return pages[0];
        }),
      medications: this.store
        .findAll('medical/medication')
        .then((medications) => {
          return medications.filter((medication) => !medication.deleted);
        }),
      batches: this.store.findAll('medical/batch'),
      schedules: this.store.findAll('medical/schedule'),
    });
  }
}
